import { PerfilParmDTO } from '@/interfaces/profiles';
import { apiClient } from '@/services/api';
import { ENDPOINTS } from '@/settings/api-settings';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

function getProfiles(filter?: {}): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.PROFILES, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

function getProfile(id: string): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PROFILES}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

function saveProfile(payload: PerfilParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.PROFILES, payload)).pipe(
    map((r: any) => r.data),
  );
}

function updateProfile(payload: PerfilParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.PROFILES, payload)).pipe(
    map((r: any) => r.data),
  );
}

export function getProfileFeaturesOptions(type: 'EMEDE' | 'CLIENTE'): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.PROFILES_FEATURES.replaceAll('{tipo}', type))).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function getProfileProfilesAccessOptions(type: 'EMEDE' | 'CLIENTE'): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.PROFILES_PROFILES_ACCESS.replaceAll('{tipo}', type))).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export { getProfile, getProfiles, saveProfile, updateProfile };

